/* @flow */

import * as React from 'react';
import {useQuery} from '@apollo/react-hooks';

import type {GetStagesets as GetStagesetsQuery} from 'nutshell-graphql-types';

import {SelectPickerSearch} from 'shells/select-picker-search/select-picker-search';

import {getDefaultStagesetId} from '../../../../util/get-default-stageset-id';
import GET_STAGESETS from '../../../lead/queries/get-stagesets.graphql';

type Props = {|
    selectedPipeline: ?string,
    onSelectPipeline: (string) => void,
    minHeight?: number,
    autoselectDefault?: boolean,
|};

export function PipelineSelectPicker(props: Props) {
    const {selectedPipeline, onSelectPipeline, autoselectDefault, minHeight} = props;
    const {data} = useQuery<GetStagesetsQuery, {}>(GET_STAGESETS, {
        notifyOnNetworkStatusChange: true,
    });

    const options = data
        ? data.stagesets.map((stageset) => {
              return {
                  label: stageset.name,
                  value: stageset.id,
              };
          })
        : [];

    const onChange = React.useCallback(
        (option) => {
            if (option && !Array.isArray(option)) {
                onSelectPipeline(option.value);
            }
        },
        [onSelectPipeline]
    );

    const value = options.find((opt) => opt.value === selectedPipeline);
    const defaultPipeline = options.find((opt) => opt.value === getDefaultStagesetId());

    React.useEffect(() => {
        if (autoselectDefault && defaultPipeline) {
            onChange(defaultPipeline);
        }
    }, [autoselectDefault, defaultPipeline, onChange]);

    return (
        <SelectPickerSearch
            minHeight={minHeight}
            placeholder='Select a pipeline…'
            autoFocus={false}
            openMenuOnFocus={true}
            preventScrollOnMenuOpen={true}
            options={options}
            onChange={onChange}
            value={value}
        />
    );
}
